<template>
  <!-- 登录页面 -->
  <div class="login">
    <div class="login-logo">
      <!-- <img src="../assets/img/loginLogo.png" alt="" /> -->
      <div class="logo x-flex">
        <img src="../../src/assets/img/logo.png" alt="logo" />
        <span class="x-p-l-10"> 服务商管理系统</span>
      </div>
    </div>
    <div class="bgcimg">
      <div class="x-abso x-right-10p x-bottom-15p bgc-f x-bd-ra-10 boxS">
        <div class="x-font-34 f600 x-text-c x-p-b-30">
          <span v-if="global.oemName !='尚米云'" class="c-ff0000">{{global.oemName}}</span>
          <!-- <span v-else class="c-ff0000">合作</span>伙伴平台 -->
          服务商登录
        </div>
        <div class="x-font-16 x-p-10-0" style="padding-top: 40px;">用户名</div>
        <div class="x-w100p x-p-b-20">
          <el-input v-model="userName" ref='userId' @keyup.enter.native="fChgFous('userId')" prefix-icon="el-icon-user"
            placeholder="请输入用户名">
          </el-input>
        </div>
        <div class="x-font-16 x-p-10-0">密码</div>
        <div class="x-w100p x-p-b-20">
          <el-input v-model="userPassword" show-password ref='psw' @keyup.enter.native="fChgFous('login')"
            prefix-icon="el-icon-lock" placeholder="请输入用密码">
          </el-input>
        </div>
        <div class="x-w100p x-p-t-40">
          <el-button style="background-color: #FB5B36;" class="x-w100p x-font-16" type="primary"
            @click="fUserLogin()">登录</el-button>
        </div>
      </div>
      <div class="verify-box" v-if="isShowImgReg">
        <!-- -->
        <slide-verify ref="slideRef" :l="42" :r="10" :w="340" :imgs="images" :h="240" slider-text="向右滑动"
          @success="onSuccess" @fail="onFail" @refresh="onRefresh" @fulfilled="onRefreshComplete" @again="onAgain">
        </slide-verify>
        <div class="tips" :class="isSuccess ? '' : 'red'">{{tipsMsg}}</div>
      </div>
      <div class="mask" v-if="isShowImgReg" @click="isShowImgReg = false"> </div>
    </div>
  </div>
</template>

<script>
  import listData from "../assets/listData/ListData.js";
  import global from '../assets/js/global.js'
  export default {
    data() {
      return {
        //图形验证码
        // identifyCode: '', //当前生成的验证码
        orgId: "372211050001",
        userName: this.$store.state.smElabelOrgInfo.userId,
        userPassword: "",
        // userdx: "", //输入的验证码
        images: [
          require('../assets/img/verCodeImg1.png'),
          require('../assets/img/verCodeImg2.png'),
          require('../assets/img/verCodeImg3.png'),
          require('../assets/img/verCodeImg4.png')
        ],
        global: global,
        tipsMsg: '',
        isSuccess: true,
        isShowImgReg: false,
        navList: listData.navList,
      };
    },
    computed: {},
    watch: {},
    created() {
      console.log(this.$store.oemName)
    },
    methods: {
      //改变焦点
      fChgFous(ref) {
        if (ref == 'orgId') {
          this.$nextTick(() => {
            this.$refs.userId.focus()
          })
        }
        if (ref == 'userId') {
          this.$nextTick(() => {
            this.$refs.psw.focus()
          })
        }
        if (ref == 'login') {
          this.fUserLogin()
        }
      },
      // 登录请求
      async fUserLogin() {
        // if (this.api.smCom.fSmIsEmpty(this.orgId)) {
        //   return this.$message("请输入机构号");
        // }
        if (this.api.smCom.fSmIsEmpty(this.userName)) {
          return this.$message("请输入用户名");
        }
        if (this.api.smCom.fSmIsEmpty(this.userPassword)) {
          return this.$message("请输入密码");
        }
        this.tipsMsg = '';
        // this.isShowImgReg = true
        // if (this.identifyCode != this.userdx) {
        //   this.$message.error("请输入图中正确验证码");
        //   return false;
        // }
        this.onSuccess()

      },

      // 成功回调
      async onSuccess() {
        this.tipsMsg = '恭喜您，验证成功啦！';
        this.isSuccess = true;
        console.log(this.$store.state.smElabelOrgInfoToken)
        let res = await this.api.smCommon.MAIN_ORG_USER_LOGIN({
          oper: 'USER_LOGIN',
          user_id: this.userName,
          user_psw: this.userPassword,
        })
        this.isShowImgReg = false
        if (res.result != 'sucess') {
          return this.$message(res.msg)
        }
        this.$store.commit('smElabelOrgInfoToken', res.token); // 存本地
        // 记录关键信息到本地
        this.$store.commit('shPhone', res.org_info.boss_phone);
        this.$store.commit('orgName', res.org_info.org_name);
        this.$store.commit('orgId', res.org_info.org_id);
        this.$store.commit('org_level', res.org_info.org_level);
        this.$store.commit('userId', res.user_info.user_id);
        this.$store.commit('userName', res.user_info.user_name);
        this.$store.commit('supperAuth', res.user_info.supper_auth);


        console.log(this.$store.state.smElabelOrgInfoToken)
        // 条件判断通过==【跳转到首页】
        this.$router.push('home');
      },
      // 失败回调
      onFail() {
        this.tipsMsg = '验证失败，请重试哦！';
        this.isSuccess = false;
      },
      // 点击刷新回调
      onRefresh() {
        this.tipsMsg = ''
      },
      // 刷新成功后回调
      onRefreshComplete() {
        // TODO
        this.tipsMsg = ''
        this.isSuccess = true;
      },
      // 检测到非人为操作
      onAgain() {
        this.tipsMsg = "再试一次吧～"
        this.$refs.slideRef.reset();
      },
      // clickDL(item) {
      //   if (this.userName != '' && this.userPassword != '' && this.userdx != '') {
      //     this.$router.push("home");
      //   }
      // },
      // ---------------------- 请求函数 开始 ------------------------
      // 登录 ORG_USER_LOGIN
    },
    beforeCreate() {},
    beforeMount() {},
    mounted() {}
  }
</script>
<style lang="less" scoped>
  .login {
    position: relative;
    width: 100%;
    height: 100%;

    .login-logo {
      position: absolute;
      top: 50px;
      left: 50px;
      z-index: 9;
      font-weight: 600;
      font-size: 24px;
    }

    // 输入宽样式
    /deep/.el-input__inner {
      height: 48px;
      line-height: 48px;
      padding-left: 40px;
      font-size: 18px;

    }

    /deep/.el-input__icon {
      font-size: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    // 按钮样式
    /deep/.el-button--primary {
      color: #FFF;
      background-color: #ff0000;
      border-color: #ff0000;
    }

    /deep/.el-button--primary:hover {
      background: #e10000;
      border-color: #e10000;
    }

    /deep/.el-button {
      padding: 15px 8px;
    }

    .bgcimg {
      position: fixed;
      width: 100%;
      height: 100%;
      background: url('../assets/img/login2.png') no-repeat;
      margin: 0px;
      background-size: 100% 100%;

      // 边框阴影
      .boxS {
        width: 480px;
        height: 570px;
        box-shadow: 0px 0px 20px 0px #BBBBBB;
        padding: 3% 4.5% 5.5%;
      }

    }

    .verify-box {
      z-index: 4;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #f4f4f4;
      padding: 10px;

      .tips {
        font-size: 18px;
        font-weight: 600;
        color: #000000;
        text-align: center;
        line-height: 40px;
      }
    }

    .mask {
      width: 100vw;
      height: 100vh;
      position: absolute;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.3);
      z-index: 2;
    }


  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue